import {signOut} from 'next-auth/react';
import AppNavMenu from './AppNavMenu';

export default function ButtonAppBar({
    drawerState,
    onDrawerStateChanged,
}: {
    drawerState: boolean;
    onDrawerStateChanged: (state: boolean) => void;
}) {
    return <AppNavMenu state={drawerState} onStateChanged={onDrawerStateChanged} signOut={signOut} />;
}
